// user_type values as emitted by the backend on each tree leaf (`user_types`).
// A disposition has no user_type of its own — it inherits these from the
// channels it is exposed on. An empty `user_types` means "global" (no channels),
// which is shown under every filter.
export const USER_TYPE = {
  PARENT: 'PARENT',
  TEACHER: 'TEACHER',
};

// Left-panel view filter. ALL leaves the tree untouched; PARENT/TEACHER narrow
// it to leaves whose user_types include that value (plus global leaves).
export const DISPOSITION_FILTER = {
  ALL: 'ALL',
  PARENT: USER_TYPE.PARENT,
  TEACHER: USER_TYPE.TEACHER,
};

export const DISPOSITION_FILTER_OPTIONS = [
  { value: DISPOSITION_FILTER.ALL, label: 'All' },
  { value: DISPOSITION_FILTER.PARENT, label: 'Parent' },
  { value: DISPOSITION_FILTER.TEACHER, label: 'Teacher' },
];

// Visual variant for a leaf's user-type tag. PARENT/TEACHER mirror the backend
// values; BOTH is UI-only (a leaf exposed on both parent and teacher channels).
export const TAG_VARIANT = {
  PARENT: USER_TYPE.PARENT,
  TEACHER: USER_TYPE.TEACHER,
  BOTH: 'BOTH',
};

export const DESCRIPTION_MAX_LENGTH = 500;
